import { CONSULTANCY_BASE_ROUTE, TABS } from '@/src/utils/constants'
import { LayoutMain } from '@layouts/LayoutMain/LayoutMain'
import React, { Suspense } from 'react'
import { Navigate, type RouteObject } from 'react-router-dom'
import { AuthRoute } from '../../routes/routes.components'

const ConsultancyUsersOverviewLazy = React.lazy(() => import('./Users/ConsultancyUsersOverview'))
const ConsultancyLocationAndDevicesOverviewLazy = React.lazy(() => import('./LocationAndDevices/ConsultancyLocationAndDevicesOverview'))
const ConsultancyCostsOverviewLazy = React.lazy(() => import('./Costs/ConsultancyCostsOverview'))
const ConsultancyRegionsOverviewLazy = React.lazy(() => import('./Regions/RegionsOverview'))
const RetoolDashboardLazy = React.lazy(() => import('./RetoolDashboard/RetoolDashboard'))
const DataGapsOverviewLazy = React.lazy(() => import('./DataGaps/DataGapsOverview'))
const UsersAndGroupsOverviewLazy = React.lazy(() => import('./UsersAndGroups/UsersAndGroupsOverview'))
const ConsultancyDataManagementOverviewLazy = React.lazy(() => import('./DataManagement/ConsultancyDataManagementOverview'))

const UsersAndGroupsOverviewPage = (
  <Suspense fallback={<div />}>
    <UsersAndGroupsOverviewLazy />
  </Suspense>
)

const ConsultancyDataManagementOverviewPage = (
  <Suspense fallback={<div />}>
    <ConsultancyDataManagementOverviewLazy />
  </Suspense>
)

const ConsultancyUsersOverviewPage = (
  <Suspense fallback={<div />}>
    <ConsultancyUsersOverviewLazy />
  </Suspense>
)

const ConsultancyLocationAndDevicesOverviewPage = (
  <Suspense fallback={<div />}>
    <ConsultancyLocationAndDevicesOverviewLazy />
  </Suspense>
)

const ConsultancyCostsOverviewPage = (
  <Suspense fallback={<div />}>
    <ConsultancyCostsOverviewLazy />
  </Suspense>
)

const RetoolDashboardPage = (
  <Suspense fallback={<div />}>
    <RetoolDashboardLazy />
  </Suspense>
)

const ConsultancyRegionsOverviewPage = (
  <Suspense fallback={<div />}>
    <ConsultancyRegionsOverviewLazy />
  </Suspense>
)

const DataGapsOverviewPage = (
  <Suspense fallback={<div />}>
    <DataGapsOverviewLazy />
  </Suspense>
)

export const getConsultancyRoutes = (): RouteObject[] => {
  const defaultRedirection = TABS.consultancy.usersAndGroups

  return [
    {
      path: CONSULTANCY_BASE_ROUTE,
      element: (
        <AuthRoute>
          <LayoutMain />
        </AuthRoute>
      ),
      children: [
        { path: '', element: <Navigate to={defaultRedirection} replace />, index: true },
        {
          path: TABS.consultancy.usersAndGroups,
          element: UsersAndGroupsOverviewPage,
          children: [
            { path: '', element: <Navigate to='users' replace /> },
            { path: 'users', element: ConsultancyUsersOverviewPage },
            { path: 'groups', element: ConsultancyRegionsOverviewPage },
          ],
        },
        {
          path: TABS.consultancy.dataManagement,
          element: ConsultancyDataManagementOverviewPage,
          children: [
            { path: '', element: <Navigate to='locations-and-devices' replace /> },
            { path: 'locations-and-devices', element: ConsultancyLocationAndDevicesOverviewPage },
            { path: 'data-gaps', element: DataGapsOverviewPage },
          ],
        },
        {
          path: TABS.consultancy.costs,
          element: ConsultancyCostsOverviewPage,
        },
        {
          path: TABS.consultancy.energieeinkauf,
          element: RetoolDashboardPage,
        },
      ],
    },
  ]
}
